import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
i18n
    .use(HttpApi) // Load translation files using http backend
    .use(LanguageDetector) // Detects user language
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
    supportedLngs: ["en", "de"],
    fallbackLng: "en", // Fallback language if the user's language is not available
    debug: false,
    interpolation: {
        escapeValue: false, // React already safes from xss
    },
    backend: {
        loadPath: "/locales/{{lng}}/translation.json?v=" + Date.now(),
    },
    detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "i18nextLng",
    },
    react: {
        transSupportBasicHtmlNodes: true,
    },
});
// A previous release persisted "hu". Keep stored preferences deterministic and
// never let language detection revive a locale that is no longer offered.
if (i18n.language !== "de" && i18n.language !== "en") {
    void i18n.changeLanguage("en");
}
export default i18n;
